export default {"src":"/_next/static/media/mobile-store-rating-stars.3d001cfc.svg","height":26,"width":128,"blurWidth":0,"blurHeight":0};